<template>
  <div class="blog-posts-page posts">
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4"
    >
      <h1 v-if="post" class="mr-2">{{ post.title }} - comments</h1>
      <div class="d-flex">
        <button
          class="btn btn-primary mr-4"
          @click.prevent="
            $router.push('/post/' + $route.params.postId + '/comments/new')
          "
        >
          <b>Add Comment</b>
        </button>
        <button
          type="button"
          class="btn btn-secondary expand-all d-flex align-items-center"
          @click="expand = !expand"
        >
          <div :class="[!expand ? 'expand-icon' : 'compress-icon']" />
        </button>
      </div>
    </div>
    <div v-if="comments && comments.length" class="row">
      <div v-for="comment in comments" :key="comment.id" class="col-md-3 mb-3">
        <div
          class="bg-white p-3 rounded review-card"
          :class="!expand ? 'expand' : ''"
        >
          <div class="d-flex flex-column">
            <span
              >Email: <strong> {{ comment.email }}</strong></span
            >
            <span
              >Name: <strong> {{ comment.name }}</strong></span
            >
            <span :title="comment.content_raw" class="pointer"
              >Comment: <strong> {{ comment.content_raw }}</strong></span
            >
          </div>
          <div class="d-flex justify-content-end options-buttons mt-3">
            <button
              class="btn btn-secondary d-flex align-items-center justify-content-center mr-2"
              style="cursor: default"
            >
              <input
                type="checkbox"
                class="pointer"
                v-model="comment.status"
                @change="updateComment(comment)"
              />
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              @click="deleteComment(comment.id)"
            >
              <i class="fa fa-trash text-danger"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="comments && !comments.length && !commentsLoading" class="claims">
      No comments added.
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "PostComments",
  data: () => ({
    comments: [],
    commentsLoading: false,
    expand: false,
    post: null
  }),
  mounted() {
    this.getPost();
    this.getComments();
  },
  methods: {
    getPost() {
      axios
        .get(`posts/${this.$route.params.postId}`)
        .then(resp => {
          this.post = resp.data.data;
        })
        .catch(err => this.errors.record(err.response.data.errors));
    },
    getComments() {
      this.commentsLoading = true;
      axios
        .get("/comments/" + this.$route.params.postId)
        .then(resp => {
          this.comments = resp.data.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.commentsLoading = false;
        });
    },
    updateComment(comment) {
      comment.content = comment.content_raw;
      axios
        .patch(`/comments/${comment.id}`, { ...comment })
        .then(() => {
          this.getComments();
          this.$vToastify.success("Comment updated.");
        })
        .catch(error => {
          console.log(error);
          this.$vToastify.error(error.message, "Error");
        });
    },
    deleteComment(commentId) {
      axios
        .delete(`/comments/${commentId}`)
        .then(() => {
          this.getComments();
          this.$vToastify.success("Comment deleted.");
        })
        .catch(error => {
          this.$vToastify.error(error.message, "Error");
        });
    }
  }
};
</script>
<style scoped>
.expand span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tags-container {
  background-color: #fff;
  border-radius: 2px;
  margin-bottom: 10px;
  padding: 10px 30px;
}
.tags-title {
  font-weight: 600;
  font-size: 16px;
  color: #4c5669;
}
.comment {
  word-break: break-all;
}

@media (max-width: 575.98px) {
  .tags-container {
    flex-direction: column-reverse;
  }
  .header-right-side {
    flex-direction: column;
  }
  .input-group {
    margin: 8px 0;
  }
  .options-buttons {
    margin: 16px 0;
  }
}
</style>
